module.exports = __webpack_public_path__ + "img/palette-1-bg.fd0b29f.jpg";